import api from '@shared/services/api';
import { Poll, PollOwnerType, PollQuestionVoters, RawPoll } from '../types/poll.types';
import { normalizePoll } from '../utils/poll.utils';

interface PollResponse {
  success: boolean;
  poll: RawPoll;
}

/** Polls of posts and of spaces are served by the same endpoints. */
export const pollService = {
  async getPollById(pollId: string): Promise<Poll> {
    const response = await api.get<PollResponse>(`/polls/${pollId}`);
    return normalizePoll(response.data.poll);
  },

  async getPollByOwner(ownerType: PollOwnerType, ownerId: string): Promise<Poll> {
    const response = await api.get<PollResponse>(`/polls/${ownerType}/${ownerId}`);
    return normalizePoll(response.data.poll);
  },

  /**
   * Answers one question with everything the person picked, which replaces
   * whatever they had picked before on that question.
   */
  async vote(pollId: string, questionId: string, optionIds: string[]): Promise<Poll> {
    const response = await api.post<PollResponse>(`/polls/${pollId}/vote`, {
      questionId,
      optionIds,
    });
    return normalizePoll(response.data.poll);
  },

  /** Who voted for what. Fails on an anonymous poll. */
  async getVoters(pollId: string): Promise<PollQuestionVoters[]> {
    const response = await api.get<{ success: boolean; questions: PollQuestionVoters[] }>(
      `/polls/${pollId}/voters`
    );
    return response.data.questions;
  },
};
